<template>
  <header
    class="min-h-12 bg-primary flex items-center justify-between px-4 py-3 text-xl font-extrabold text-textGray"
  >
    <h3>IWC Reimbursement</h3>

    <div v-if="$store.state.ifAuthorized" class="icon" @click="logoutHandler()">
      Logout
    </div>
  </header>
</template>

<script>
import { inject } from "vue";
export default {
  components: {},
  setup() {
    const axios = inject("$axios");
    const router = inject("$router");
    const logoutHandler = async () => {
      await axios.post(`/portal/auth/logout`);
      return router.push("/");
    };
    return {
      logoutHandler,
    };
  },
};
</script>
